// kz-layout.js
(function () {
  function moveKZ() {
    // 1) Target header row (prefer a rich-text with a heading in it)
    let inner =
      document.querySelector('.rich-text__inner:has(.rich-text__heading)') ||
      document.querySelector('.rich-text__inner');
    if (!inner) return;

    // 2) Pick the keuzehulp block we actually want (visible one)
    const ctas = Array.from(document.querySelectorAll('.keuzehulp-cta'));
    const visibleCTA = ctas.find(el => el.offsetParent !== null);
    if (!visibleCTA) return;

    // If it’s already inside the same row and layout applied, stop
    if (visibleCTA.closest('.rich-text__inner') === inner &&
        inner.classList.contains('kz-row')) return;

    // 3) Build a left column (heading + text/USPs) if not present
    let left = inner.querySelector('.kz-left');
    if (!left) {
      left = document.createElement('div');
      left.className = 'kz-left';

      // Move all existing children except any keuzehulp container into the left column
      Array.from(inner.children).forEach(child => {
        if (!child.classList.contains('keuzehulp-cta') &&
            !child.classList.contains('kz-left')) {
          left.appendChild(child);
        }
      });

      inner.prepend(left);
    }

    // 4) Move the visible CTA into the header row (right side)
    inner.appendChild(visibleCTA);

    // 5) Mark for CSS layout
    inner.classList.add('kz-row');
  }

  document.addEventListener('DOMContentLoaded', moveKZ);
  document.addEventListener('shopify:section:load', moveKZ);
  document.addEventListener('shopify:section:select', moveKZ);
  new MutationObserver(moveKZ).observe(document.body, { childList: true, subtree: true });
})();